"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_MAX_LENGTH = void 0;
/* istanbul ignore file @preserve --constants  */
const URL_MAX_LENGTH = exports.URL_MAX_LENGTH = 2000;
